import React, { useEffect, useState } from "react";
import axios from "axios"; 
import { useParams, useNavigate, Link } from "react-router-dom";
import config from '../../config';

function ReviewDetails() {
    const { id } = useParams();
    const [review, setReview] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [activeLanguage, setActiveLanguage] = useState('en');
    const navigate = useNavigate();

    const fetchReviewDetails = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-review-admin/${id}`, { 
                withCredentials: true 
            });
            setReview(response.data);
        } catch (err) {
            setError('Failed to fetch review details');
            console.error('Error fetching review:', err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchReviewDetails();
    }, [id]);

    const switchLanguage = (lang) => {
        setActiveLanguage(lang);
    };

    const handleDelete = async () => {
        const confirmDelete = window.confirm('Are you sure you want to delete this review? This action cannot be undone.');
        if (!confirmDelete) return;

        try {
            await axios.delete(`${config.BASE_URL}/api/admin/delete-review/${id}`, { 
                withCredentials: true 
            });
            navigate('/admin/reviews'); 
        } catch (err) {
            setError('Failed to delete the review');
            console.error('Error deleting review:', err);
        }
    };

    if (loading) return <div className="dashboard"><div className="container"><p>Loading...</p></div></div>;
    if (error) return <div className="dashboard"><div className="container"><p className="error-message">{error}</p></div></div>;
    if (!review) return <div className="dashboard"><div className="container"><p>Review not found.</p></div></div>;

    return (
        <div className="dashboard project_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Dashboard</h1>
                <div className="back_btn_wrap">
                    <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                </div>

                {/* Language Tabs */}
                <div className="language-tabs" style={{ marginBottom: '20px' }}>
                    <button 
                        type="button" 
                        className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                        onClick={() => switchLanguage('en')}
                        style={{
                            padding: '10px 20px',
                            marginRight: '10px',
                            backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                            color: activeLanguage === 'en' ? 'white' : 'black',
                            border: '1px solid #ddd',
                            cursor: 'pointer',
                            borderRadius: '4px'
                        }}
                    >
                        English
                    </button>
                    <button 
                        type="button" 
                        className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                        onClick={() => switchLanguage('es')}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                            color: activeLanguage === 'es' ? 'white' : 'black',
                            border: '1px solid #ddd',
                            cursor: 'pointer',
                            borderRadius: '4px'
                        }}
                    >
                        Spanish
                    </button>
                </div>

                <div className="main-section">
                    <div className="projects">
                        <div className="projects-inner">
                            {/* English Content */}
                            {activeLanguage === 'en' && (
                                <div className="language-content">
                                    <h3 style={{ marginBottom: '20px', color: '#007bff' }}>English Content</h3>

                                    <div className="detail_item">
                                        <h2>Language</h2>
                                        <div className="detail_item_inner">
                                            <p>{review.language || 'en'}</p>
                                        </div>
                                    </div>

                                    <div className="detail_item">
                                        <h2>Title</h2>
                                        <div className="detail_item_inner">
                                            <p>{review.title || 'No title provided'}</p>
                                        </div>
                                    </div>

                                    {/* <div className="detail_item">
                                        <h2>Slug</h2>
                                        <div className="detail_item_inner">
                                            <p>{review.slug || 'No slug provided'}</p>
                                        </div>
                                    </div> */}

                                    <div className="detail_item">
                                        <h2>Description</h2>
                                        <div className="detail_item_inner">
                                            <p>{review.description || 'No description provided'}</p>
                                        </div>
                                    </div>

                                    <div className="detail_item">
                                        <h2>Client Name</h2>
                                        <div className="detail_item_inner">
                                            <p>{review.clientname || 'No client name provided'}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Spanish Content */}
                            {activeLanguage === 'es' && (
                                <div className="language-content">
                                    <h3 style={{ marginBottom: '20px', color: '#007bff' }}>Spanish Content</h3>

                                    <div className="detail_item">
                                        <h2>Language</h2>
                                        <div className="detail_item_inner">
                                            <p>{review.spanishData?.language || 'es'}</p>
                                        </div>
                                    </div>

                                    <div className="detail_item">
                                        <h2>Title</h2>
                                        <div className="detail_item_inner">
                                            <p>{review.spanishData?.title || 'No se proporcionó título'}</p>
                                        </div>
                                    </div>

                                    {/* <div className="detail_item">
                                        <h2>Slug</h2>
                                        <div className="detail_item_inner">
                                            <p>{review.spanishData?.slug || 'No se proporcionó slug'}</p>
                                        </div>
                                    </div> */}

                                    <div className="detail_item">
                                        <h2>Description</h2>
                                        <div className="detail_item_inner">
                                            <p>{review.spanishData?.description || 'No se proporcionó descripción'}</p>
                                        </div>
                                    </div>

                                    <div className="detail_item">
                                        <h2>Client Name</h2>
                                        <div className="detail_item_inner">
                                            <p>{review.spanishData?.clientname || 'No se proporcionó nombre del cliente'}</p>
                                        </div>
                                    </div>

                                    {!review.spanishData?.title && !review.spanishData?.description && !review.spanishData?.clientname && !review.spanishData?.slug && (
                                        <div style={{ 
                                            padding: '15px', 
                                            backgroundColor: '#f8f9fa', 
                                            border: '1px solid #dee2e6', 
                                            borderRadius: '4px',
                                            marginTop: '10px'
                                        }}>
                                            <p style={{ margin: 0, color: '#6c757d', fontStyle: 'italic' }}>
                                                No Spanish translation available for this review.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Featured Image - Always Visible */}
                            <div className="detail_item">
                                <div className="detail_banner_wrap">
                                    <div className="detail_img_grid">
                                        {review.featuredImage ? (
                                            <div className="detail_img_item">
                                                <h2>Featured Image</h2>
                                                <div className="banner_img_wrap">
                                                    <img 
                                                        src={`${config.BASE_URL}${review.featuredImage}`} 
                                                        alt="Featured" 
                                                        style={{ maxWidth: '100%', height: 'auto' }}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <h2>Featured Image</h2>
                                                <p>No image available.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Review Metadata */}
                            <div className="detail_item">
                                <h2>Review Information</h2>
                                <div className="detail_item_inner">
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '10px' }}>
                                        <div>
                                            <strong>Created:</strong> 
                                            <p style={{ margin: '5px 0' }}>
                                                {review.created_at ? new Date(review.created_at).toLocaleDateString() : 'N/A'}
                                            </p>
                                        </div>
                                        <div>
                                            <strong>Last Updated:</strong>
                                            <p style={{ margin: '5px 0' }}>
                                                {review.updated_at ? new Date(review.updated_at).toLocaleDateString() : 'N/A'}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="detail_project_btn_wrap">
                                <div className="detail_edit_del">
                                    <div className="btn_item">
                                        <button 
                                            className="detail_btns" 
                                            onClick={handleDelete}
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: 'white',
                                                border: 'none',
                                                padding: '10px 20px',
                                                borderRadius: '4px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                    <div className="btn_item">
                                        <Link 
                                            to={`/admin/update-review/${review._id}`} 
                                            className="update_detail detail_btns"
                                            style={{
                                                backgroundColor: '#28a745',
                                                color: 'white',
                                                textDecoration: 'none',
                                                padding: '10px 20px',
                                                borderRadius: '4px',
                                                display: 'inline-block'
                                            }}
                                        >
                                            Edit
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReviewDetails;
